import { render, staticRenderFns } from "./TooltipDiscountCover.vue?vue&type=template&id=e966e49a&scoped=true&"
import script from "./TooltipDiscountCover.vue?vue&type=script&lang=js&"
export * from "./TooltipDiscountCover.vue?vue&type=script&lang=js&"
import style0 from "./TooltipDiscountCover.vue?vue&type=style&index=0&id=e966e49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e966e49a",
  null
  
)

export default component.exports